import { render } from "./PageWithHeader.vue?vue&type=template&id=718f9c8a&scoped=true&ts=true"
import script from "./PageWithHeader.vue?vue&type=script&lang=ts"
export * from "./PageWithHeader.vue?vue&type=script&lang=ts"

import "./PageWithHeader.vue?vue&type=style&index=0&id=718f9c8a&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-718f9c8a"]])

export default __exports__